export enum NotificationType {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    WARNING = 'warning',
    INFO = 'info',
    PD_EMAIL_ERROR = 'pdemail',
    EMAIL_EXISTS_ERROR = 'email_exists'
}
